/**
 * Feature flag for the "What's New" changelog page (LSP-17882). Runtime env
 * (config/env.json → window.env), so it can be flipped per environment without a
 * code change. Enabled only when VITE_ENABLE_WHATS_NEW is exactly "true"; anything
 * else (unset / "false") hides the nav entries and blocks the /whats-new route.
 */
export function isWhatsNewEnabled(): boolean {
	return window.env?.VITE_ENABLE_WHATS_NEW === "true";
}
